<template>
  <div id="analyze-info">
    <div style="width: 100%;max-height: 100%;" v-if="showSP">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">
          <div class="card-list">
            <AnalyzeCard
              :grade="grade"
              style="margin-bottom: 3vw"
              v-for="(item,index) in slide.info"
              :key="index"
              :title="item.title"
              :right="item.right"
              :total="item.total"
              :info="addBr(item.info)"
            ></AnalyzeCard>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div id="gobackIcon" class="back" @click="goback">
      <i class="el-icon-back"></i>
    </div>
  </div>
</template>
<script>
// import TabBanner from '@/assets/imgs/tab-banner1.png'
import AnalyzeCard from "@/common/AnalyzeCard";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    AnalyzeCard,
    swiper,
    swiperSlide
  },
  props: {
    testId: {},
    id: {},
    grade: {},
    fotmat: {}
  },
  data() {
    let self = this;
    return {
      showSP: false,
      analyzeData: [
        {
          tab: "语言艺术主题",
          info: [
            {
              title: "项目管理能力",
              right: "9",
              total: "9",
              info: "语言艺术主题,语言艺术主题"
            }
          ]
        },
        {
          tab: "未来领导力",
          info: [
            {
              title: "项目管理能力",
              right: "3",
              total: "9",
              info: "未来领导力,未来领导力"
            }
          ]
        },
        {
          tab: "科学主题",
          info: [
            {
              title: "项目管理能力",
              right: "9",
              total: "9",
              info: "科学主题,科学主题"
            }
          ]
        },
        {
          tab: "数学主题",
          info: [
            {
              title: "项目管理能力",
              right: "9",
              total: "9",
              info: "数学主题,数学主题"
            }
          ]
        }
      ],
      swiperSlides: [],
      swiperOption: {
        initialSlide: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return (
              '<span class="' +
              className +
              '">' +
              "<span>" +
              self.setSlidesName(index) +
              "</span>" +
              "</span>"
            );
          }
        }
      }
    };
  },
  created() {
    console.log(this.$route.params.format);
    this.$http(`student-participant/${this.testId}/${this.grade}`)
      .then(res => {
        res.data.forEach((item, index) => {
          if (item.tab === this.$route.params.format) {
            this.swiperOption.initialSlide = index;
            console.log(this.swiperOption);
            this.showSP = true;
          }
        });
      })
      .catch(err => {
        alert("当前接口暂时无法访问");
      });
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$http(`student-participant/${this.testId}/${this.grade}`)
        .then(res => {
          this.analyzeData = res.data;
          console.log(this.analyzeData);
          this.setSlides();
          this.setPaginationBackImg();
          this.$nextTick(function() {
            this.setPaginationBottomSpan();
            document.getElementById(
              "gobackIcon"
            ).style.background = this.$util.tabHeightLightColor(this.grade);
          });
        })
        .catch(err => {
          console.log("当前接口暂时无法访问", err);
        });
    },
    goback() {
      this.$router.push({ path: `/main/${this.testId}/${this.grade}` });
    },
    setSlides() {
      console.log(JSON.stringify(this.analyzeData));
      this.analyzeData.forEach((item, index) => {
        this.swiperSlides.push(item);
      });
    },
    setSlidesName(index) {
      return this.analyzeData[index].tab;
    },
    setPaginationBackImg() {
      let pagination = document.getElementsByClassName("swiper-pagination");
      pagination[0].style.backgroundImage =
        "url(" +
        require("../assets/imgs/" + this.grade + "/tab-banner1.png") +
        ")";
    },
    setPaginationBottomSpan() {
      let paginationItem = document.getElementsByClassName(
        "swiper-pagination-bullet"
      );
      for (let i = 0; i < paginationItem.length; i++) {
        let span = document.createElement("span");
        span.className = "tab-bottom";
        span.style.border = "2px solid";
        span.style.borderColor = this.$util.tabHeightLightColor(this.grade);
        span.style.width = "56px";
        span.style.bottom = "-8px";
        span.style.left = "50%";
        span.style.borderRadius = "20px";
        span.style.transform = "translateX(-50%)";
        paginationItem[i].style.color = this.$util.tabNormalColor(this.grade);
        paginationItem[i].appendChild(span);
      }
      let style = document.createElement("style");
      style.innerHTML =
        ".swiper-pagination-bullet-active{color: " +
        this.$util.tabHeightLightColor(this.grade) +
        " !important}";
      document.getElementsByTagName("head")[0].appendChild(style);
    },
    addBr(val) {
      return (val + "").replace(/\n/g, "<br/>");
    }
  }
};
</script>
<style lang="scss" scoped>
#analyze-info {
  width: 100%;
  height: 100%;
  background: #eee;
  position: relative;
  .card-list {
    margin-top: 30px;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .back {
    position: absolute;
    bottom: 5%;
    left: 5%;
    padding: 50px;
    box-shadow: 1px 1px 10px 2px #999;
    border-radius: 50%;
    z-index: 99999999;
    i {
      color: #fff;
      font-size: 100px;
    }
  }
}
.swiper-pagination {
  /*background-image: url("../assets/imgs/tab-banner1.png");*/
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AnalyzeInfo.vue